// Copyright (c) 2016 Deere & Company

import {isDealerSettingsValid} from '../../dealer-settings/services/form-validation';

export function handleOnPageLeave(nextLocation, props) {

    if (props.isSaved === false) {

        props.actions.updateNextLocation(nextLocation.pathname);

        if (((props.userDealerSettings) && !isDealerSettingsValid(props.userDealerSettings.accounts))) {

            props.actions.resetUserSettings(nextLocation);

            return props.isSaved;

        }

        props.actions.updateConfirmSaveModalVisibility(true);

    }

    return props.isSaved;

}



// WEBPACK FOOTER //
// ./src/user/shared/services/handle-on-page-leave.js